
import './FlowerShop.css';
import React, { useState } from "react";
import flowers from '../assets/constants/flowers.js'
import awnings from '../assets/constants/awnings.js'
import flowerPot from '../assets/images/flowerPot.png'
import flowerBasket from '../assets/images/flowerBasket.png'
import brickHeader from '../assets/images/brickHeader.png'
import leafCluster from '../assets/images/leafCluster.png';

function FlowerShop(props) {
    const [activeAwning, setActiveAwning] = useState(0)
    const [shoppedFlowers, setShoppedFlowers] = useState(props.selectedFlowers)

    function changeActiveAwning(change) {
        if (change === -1 && activeAwning !== 0) {
            setActiveAwning(activeAwning - 1)
        }
        if (change === 1 && activeAwning !== awnings.length - 1) {
            setActiveAwning(activeAwning + 1)
        }
        if (change === -1 && activeAwning === 0) {
            setActiveAwning(awnings.length - 1)
        }
        if (change === 1 && activeAwning === awnings.length - 1) {
            setActiveAwning(0)
        }
    }

    function addFlowerToBasket(flower) {
        if (shoppedFlowers.length < 12) {
            let shoppedFlowersCopy = [...shoppedFlowers]
            shoppedFlowersCopy.push(flower)
            setShoppedFlowers(shoppedFlowersCopy)
            props.setSelectedFlowers(shoppedFlowersCopy)
        }
    }

    function removeLastFlower() {
        let shoppedFlowersCopy = [...shoppedFlowers]
        shoppedFlowersCopy.pop()
        setShoppedFlowers(shoppedFlowersCopy)
        props.setSelectedFlowers(shoppedFlowersCopy)
    }

    function saveAndMoveForward() {
        props.setSelectedFlowers(shoppedFlowers)
        window.scrollTo(0, 0)
        props.setActiveStatus("bouquet arrange")
    }

    return (
        <div>
            <img src={brickHeader} alt="e-florals flower shop sign on a white brick building" className="brickHeaderimage" />
            <p onClick={() => changeActiveAwning(-1)} className="awningArrow leftAwningArrow"> {'<'} </p>
            <p onClick={() => changeActiveAwning(1)} className="awningArrow rightAwningArrow"> {'>'} </p>
            <h1 className="colorText">{awnings[activeAwning].color}</h1>
            <img className="awningImage" src={awnings[activeAwning].awning} alt={"a " + awnings[activeAwning].color + "striped roof awning"} />
            <div style={{ display: 'flex' }}>
                
                <div>
                                        <div className="flowersInBag">
                                            <img className="flowershopClusterImage" src={leafCluster} alt="green leaf cluster"/>
                        {shoppedFlowers.map((flower, index) => (
                            <img key={index} className={"flowerImageLarge flowerImage" + index} src={flowers[flower].img} alt={flowers[flower].name} />
                        ))}
                    </div>
                    <img className="flowerBasketImage" src={flowerBasket} alt="a soft beige bag for holding flowers" />
                    <div className="blackBox smallBlackBoxLeft">
                        <p onClick={() => removeLastFlower()} className="removeFlower"> remove last flower </p>
                        <p className={shoppedFlowers.length === 12 ? "removeFlower removeFlowerRedButton" : "removeFlower"}> currently selected: {shoppedFlowers.length} / 12 flowers </p>
                        <p onClick={() => saveAndMoveForward()} className="navButton flowershopNavButton"> start arranging flowers </p>
                    </div>
                </div>
                <div className="blackBox smallBlackBoxRight">
                    {/* <p className="removeFlower clickToAddText"> click a flower to add it to your basket </p> */}
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {flowers.filter((flower) => flower.color === awnings[activeAwning].color).map((flower, index) => (
                            <div onClick={() => addFlowerToBasket(flower.index)} key={index}>
                                <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                                    <img className="flowerSmallImage flowerSmallImage0" src={flower.img} alt={flower.name} />
                                    <img className="flowerSmallImage flowerSmallImage1" src={flower.img} alt={flower.name} />
                                    <img className="flowerSmallImage flowerSmallImage2" src={flower.img} alt={flower.name} />
                                    <img className="flowerSmallImage flowerSmallImage3" src={flower.img} alt={flower.name} />
                                    <img className="flowerSmallImage flowerSmallImage4" src={flower.img} alt={flower.name} />
                                    <img className="flowerSmallImage flowerSmallImage5" src={flower.img} alt={flower.name} />
                                    <img className="flowerSmallImage flowerSmallImage6" src={flower.img} alt={flower.name} />
                                    <img className="flowerSmallImage flowerSmallImage7" src={flower.img} alt={flower.name} />
                                </div>
                                <img className="flowerpotImage" src={flowerPot} alt="a small round black flower pot with a white label" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FlowerShop;